import React, { Component } from 'react';
import { connect } from 'react-redux';
import './MasterSelection.scss';

class MasterSelection extends Component {

    mainMenuName = 'Master';

    constructor(props) {
        super(props);
        this.state = {
            expandedModules: {}
        };
    }

    toggleModule = (moduleName) => {
        this.setState(prev => ({
            expandedModules: {
                ...prev.expandedModules,
                [moduleName]: !prev.expandedModules[moduleName]
            }
        }));
    };

    getGroupedTiles = () => {
        const { menuLists } = this.props;
        if (!menuLists || !menuLists.length) return {};

        const menuBlock = menuLists.find(m => m.mainmenu === this.mainMenuName);
        if (!menuBlock || !menuBlock.menuRights.length) return {};

        const Lang = localStorage.getItem('Lang') || 'En';

        let rights = menuBlock.menuRights.filter(sub => sub.viewAccess === true);

        let tiles = rights.map(sub => ({
            label: Lang === 'En' ? sub.subMenuName : (sub.subMenuNameAr || sub.subMenuName),
            to: '/' + sub.url,
            icon: sub.smicon,
            module: sub.module || 'General',
        }));

        // Deduplicate by label
        tiles = tiles.filter((ele, ind) =>
            ind === tiles.findIndex(elem => elem.label === ele.label)
        );

        // Group by module
        return tiles.reduce((groups, tile) => {
            const key = tile.module;
            if (!groups[key]) groups[key] = [];
            groups[key].push(tile);
            return groups;
        }, {});
    };

    handleTileClick = (tile) => {
        if (tile.to) {
            this.props.history.push(tile.to);
        }
    };

    render() {
        const grouped = this.getGroupedTiles();
        const moduleNames = Object.keys(grouped);
        const { expandedModules } = this.state;

        const moduleIcons = {
            'Human Resource': 'pi pi-fw pi-users',
            'Administration': 'pi pi-fw pi-cog',
            'Finance':        'pi pi-fw pi-dollar',
            'Inventory':      'pi pi-fw pi-box',
            'General':        'pi pi-fw pi-th-large',
            'Property Management': 'pi pi-fw pi-building',
        };

        return (
            <div className="p-grid master-selection">
                <div className="p-col-12">
                    <div className="card card-w-title">

                        <h1 className="master-selection__title">
                            <i className="pi pi-fw pi-users" />
                            {this.mainMenuName}
                        </h1>

                        {moduleNames.length === 0 ? (
                            <div className="master-selection__empty">
                                <i className="pi pi-lock" />
                                <p>No authorized pages found.</p>
                            </div>
                        ) : (
                            moduleNames.map((moduleName) => {
                                const isOpen = !!expandedModules[moduleName];
                                const tiles  = grouped[moduleName];

                                return (
                                    <div
                                        key={moduleName}
                                        className={`master-selection__panel ${isOpen ? 'master-selection__panel--open' : ''}`}
                                    >
                                        {/* Panel Header */}
                                        <div
                                            className="master-selection__panel-header"
                                            onClick={() => this.toggleModule(moduleName)}
                                        >
                                            <div className="master-selection__panel-header-left">
                                                <i className={moduleIcons[moduleName] || 'pi pi-fw pi-folder'} />
                                                <span>{moduleName}</span>
                                                <span className="p-badge">{tiles.length}</span>
                                            </div>
                                            <i className={`pi master-selection__panel-header-arrow ${isOpen ? 'pi-angle-up' : 'pi-angle-down'}`} />
                                        </div>

                                        {/* Panel Body */}
                                        {isOpen && (
                                            <div className="master-selection__panel-body">
                                                <div className="p-grid">
                                                    {tiles.map((tile, idx) => (
                                                        <div key={idx} className="p-col-12 p-md-4 p-lg-3">
                                                            <div
                                                                className="master-selection__tile"
                                                                onClick={() => this.handleTileClick(tile)}
                                                            >
                                                                <i className={tile.icon || 'pi pi-fw pi-file'} />
                                                                <span>{tile.label}</span>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                );
                            })
                        )}

                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    menuLists: state.auth.menuLists,
});

export default connect(mapStateToProps)(MasterSelection);